export default {
  isMobile() {
    // aler(navigator.userAgent)
    return /ANDROID|WEBOS|IPHONE|IPAD|IPOD|BLACKBERRY|IEMOBILE|OPERA MINI/i.test(
      navigator.userAgent.toUpperCase(),
    )
  },
  isIosMobile() {
    // alert(navigator.userAgent)
    return /IPHONE|IPAD|IPOD/i.test(navigator.userAgent.toUpperCase())
  },
  // is PWA app installed
  isInStandaloneMode() {
    return (
      window.matchMedia('(display-mode: standalone)').matches
      || ('standalone' in navigator && navigator.standalone)
    )
  },
  isBrowserCompatible() {
    if (this.isMobile()) {
      if (this.isIosMobile()) {
        return this.isIosSafari()
      }
      if (/ANDROID/i.test(navigator.userAgent.toUpperCase())) {
        return true
      }
    } else if (
      /Chrome/.test(navigator.userAgent)
      && /Google Inc/.test(navigator.vendor)
    ) {
      return true
    }

    return false
  },
  isIosSafari() {
    return (
      /iP(ad|od|hone)/i.test(navigator.userAgent)
      && /WebKit/i.test(navigator.userAgent)
      && !/(CriOS|FxiOS|OPiOS|EdgiOS|mercury)/i.test(navigator.userAgent)
      && !this.isInAppBrowser()
    )
  },
  /**
   * Navegador embutido de app (WhatsApp, Instagram, Facebook, LinkedIn...).
   * Nenhum deles instala PWA: no iOS não existe o menu Compartilhar > Adicionar
   * à Tela de Início e no Android o WebView não emite beforeinstallprompt.
   * A maioria dos clientes chega pelo link do WhatsApp, então é o caso comum.
   */
  isInAppBrowser() {
    const ua = navigator.userAgent
    if (/(FBAN|FBAV|FB_IAB|Instagram|Line|LinkedInApp|MicroMessenger|Twitter)/i.test(ua)) {
      return true
    }
    // WhatsApp: iOS manda "WhatsApp" no UA; no Android é WebView (wv) ou
    // WebKit puro sem a marca Safari/Chrome.
    if (/WhatsApp/i.test(ua)) return true
    if (/Android/i.test(ua) && /; wv\)/i.test(ua)) return true
    if (/iP(ad|od|hone)/i.test(ua) && /AppleWebKit/i.test(ua) && !/Safari/i.test(ua)) {
      return true
    }
    return false
  },
}
